import { render, staticRenderFns } from "./ComboboxComponent.vue?vue&type=template&id=1bd31326&"
import script from "./ComboboxComponent.vue?vue&type=script&lang=ts&"
export * from "./ComboboxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports